<template>
  	<div class="builder-row">
		<div class="title-column" :class="{ 'no-title': !label || label.length == 0 }">
			<span>{{ label }}</span>
			<button-remove v-if="removeable" @remove="$emit('remove')" class="md:hidden"></button-remove>
		</div>

		<slot></slot>
		
		<button-remove v-if="removeable" @remove="$emit('remove')" class="hidden md:block"></button-remove>
  	</div>
</template>

<script>
import ButtonRemove from "./ButtonRemove.vue"

export default {
	components: { ButtonRemove },
	props: {
		label: String,
		removeable: Boolean,
	},
	emits: ["remove"],
};
</script>